/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Avatar,
  CircularProgress,
} from '@material-ui/core';
import { LockOutlined as LockOutlinedIcon } from '@material-ui/icons';

import {
  validateReviewByGuestId,
  selectIsPending,
} from '../../store/widgetSlice';

import {
  setMessage,
} from '../../store/authSlice';

import {
  isRequired,
  validateField,
  validateForm,
} from '../../helpers/validation';

const useStyles = makeStyles((theme) => ({
  form: {
    width: 450,
    maxWidth: '100%',
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  heading: {
    fontWeight: 600,
    margin: theme.spacing(1, 0),
  },
  description: {
    fontSize: 12,
    margin: theme.spacing(1, 0, 2),
  },
  rating: {
    marginLeft: -2,
  },
  radioGroup: {
    marginBottom: theme.spacing(2),
  },
  radioHelperText: {
    marginTop: -theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  surveyTextField: {
    width: `calc(100% - ${theme.spacing(2)}px)`,
    marginTop: -theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  pendingProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    marginTop: '5px',
    zIndex: 1,
  },
  paper: {
    margin: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  elementHidden: {
    display: 'none',
  },
}));

export default function GuestAccessForm({ reviewId }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isPending = useSelector(selectIsPending);

  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    guestId: '',
  });

  const formRules = {
    guestId: [isRequired],
  };

  function handleChange(event) {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  }

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const attemptValidateReview = (event) => {
    event.preventDefault();
    if (validateForm(formRules, formValues, formErrors, setFormErrors)) {
      dispatch(validateReviewByGuestId({
        reviewId,
        guestId: formValues.guestId,
      }))
        .unwrap()
        .then(() => {
          dispatch(setMessage({ message: 'Review retrieved', severity: 'success' }));
        })
        .catch(() => {
          dispatch(setMessage({ message: 'Review associated to code could not be found.', severity: 'error' }));
        });
    }
  };

  return (
    <form className={classes.form}>
      <Box align="center" className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        {isPending && <CircularProgress size={46} className={classes.pendingProgress} />}
        <Typography align="center" component="h1" variant="h5">Guest Area</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid align="left" item sm={12}>
          <TextField
            variant="outlined"
            margin="normal"
            id="review-guest-id"
            label="Enter code"
            name="guestId"
            value={formValues.guestId}
            error={!!formErrors.guestId}
            helperText={formErrors.guestId}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={attemptValidateReview}
        disabled={isPending}
        fullWidth
      >
        Validate
      </Button>
    </form>
  );
}
